import React from 'react';

import { Divider, Item, Key, List, Title, Value } from './components';
import * as S from './styles';

interface ISummary extends React.FC {
  Divider: typeof Divider;
  Item: typeof Item;
  Key: typeof Key;
  List: typeof List;
  Title: typeof Title;
  Value: typeof Value;
}

const Summary: ISummary = ({ children }) => (
  <S.Container>{children}</S.Container>
);

Summary.Divider = Divider;
Summary.Divider.displayName = 'Summary.Divider';
Summary.Key = Key;
Summary.Key.displayName = 'Summary.Key';
Summary.Item = Item;
Summary.Item.displayName = 'Summary.Item';
Summary.List = List;
Summary.List.displayName = 'Summary.List';
Summary.Title = Title;
Summary.Title.displayName = 'Summary.Title';
Summary.Value = Value;
Summary.Value.displayName = 'Summary.Value';

export default Summary;
